export const buildCategoryTree = categories => {
  const roots = [];

  categories.forEach(category => {
    const find = categories.find(temp => temp.value === category.parent_id.toString());

    if (!find) {
      roots.push(category);
    } else {
      if (!find.children) {
        find.children = [];
      }

      find.children.push(category);
    }
  });

  return roots;
};
